<template>
  <div>
    <div
      :class="
        `p-10 w-32 h-32 rounded-full text-${color}-600 bg-${color}-200 flex items-center justify-center mx-auto`
      "
    >
      <span class="font-bold" style="font-size: 3rem;">
        <span>{{ score }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { getColorForScore } from "@/utils/pagespeed";

export default {
  name: "MoskitoPieScore",
  props: {
    score: {
      type: Number,
      required: true,
    },
  },
  computed: {
    color() {
      return getColorForScore(this.score);
    },
  },
};
</script>

<style></style>
